import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import { AuthProvider } from './context/AuthContext';
import { UIProvider } from './context/UIContext';
import { HelmetProvider } from 'react-helmet-async';
import ScrollToTop from './components/ScrollToTop';
import HomePage from './pages/HomePage';
import CategoryPage from './pages/CategoryPage';
import Profile from './pages/Profile';
import InfoPage from './pages/InfoPage';
import WidgetDetailPage from './pages/WidgetDetailPage';
import Contact from './pages/Contact';
import ChessConsulting from './pages/ChessConsulting';
import CreatorPageTemplate from './pages/TrendingChess';
import BlogsPage from './pages/BlogsPage';
import BlogPostPage from './pages/BlogPostPage';
import AdminPage from './pages/AdminPage';
import BlogEditorPage from './pages/BlogEditorPage';
import WidgetsAdminPage from './pages/WidgetsAdminPage';
import WidgetEditorPage from './pages/WidgetEditorPage';
import ContentEditorPage from './pages/ContentEditorPage';
import ContentPipelinePage from './pages/ContentPipelinePage';
import OutreachPage from './pages/OutreachPage';
import CalendarAdminPage from './pages/CalendarAdminPage';
import InstagramAdminPage from './pages/InstagramAdminPage';
import SubmitPage from './pages/SubmitPage';
import TwoSevenZeroOnePage from './pages/TwoSevenZeroOnePage';

function App() {
  return (
    <HelmetProvider>
    <UIProvider>
      <AuthProvider>
        <Router>
          <ScrollToTop />
          <div className="min-h-screen bg-gray-900">
            {/* Main Content Area */}
            <main className="min-h-screen">
              <div>
                <AnimatePresence mode="wait">
                  <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/people" element={<CategoryPage category="people" />} />
                    <Route path="/creators" element={<Navigate to="/people" replace />} />
                    <Route path="/play" element={<CategoryPage category="play" />} />
                    <Route path="/learn" element={<CategoryPage category="learn" />} />
                    <Route path="/analysis" element={<CategoryPage category="analysis" />} />
                    <Route path="/openings" element={<CategoryPage category="openings" />} />
                    <Route path="/books" element={<CategoryPage category="books" />} />
                    <Route path="/events" element={<CategoryPage category="events" />} />
                    <Route path="/tournaments" element={<Navigate to="/events" replace />} />
                    <Route path="/new" element={<CategoryPage category="new" />} />
                    {/* Redirects from old stale category URLs */}
                    <Route path="/scroll" element={<Navigate to="/" replace />} />
                    <Route path="/practice" element={<Navigate to="/learn" replace />} />
                    <Route path="/create" element={<Navigate to="/" replace />} />
                    <Route path="/irl" element={<Navigate to="/events" replace />} />
                    <Route path="/more" element={<Navigate to="/" replace />} />
                    <Route path="/profile" element={<Profile />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route path="/chess-consulting" element={<ChessConsulting />} />
                    <Route path="/TrendingChess" element={<CreatorPageTemplate />} />
                    <Route path="/Charlize" element={<CreatorPageTemplate />} />
                    {/* Legacy internal tools (hardcoded coming-soon pages) */}
                    <Route path="/internal-tool/:toolId" element={<InfoPage />} />
                    <Route path="/blogs" element={<BlogsPage />} />
                    <Route path="/blog/:slug" element={<BlogPostPage />} />
                    <Route path="/admin" element={<AdminPage />} />
                    <Route path="/admin/blog/new" element={<BlogEditorPage />} />
                    <Route path="/admin/blog/edit/:id" element={<BlogEditorPage />} />
                    <Route path="/submit" element={<SubmitPage />} />
                    {/* Consolidated admin pages */}
                    <Route path="/admin/content" element={<ContentPipelinePage />} />
                    <Route path="/admin/outreach" element={<OutreachPage />} />
                    <Route path="/admin/calendar" element={<CalendarAdminPage />} />
                    <Route path="/admin/instagram" element={<InstagramAdminPage />} />
                    {/* Redirects for old standalone routes */}
                    <Route path="/admin/tweets" element={<Navigate to="/admin/content" replace />} />
                    <Route path="/admin/blogs" element={<Navigate to="/admin/content" replace />} />
                    <Route path="/admin/submissions" element={<Navigate to="/admin/widgets?tab=submissions" replace />} />
                    {/* Content editor (deep link) */}
                    <Route path="/admin/content/editor/:id" element={<ContentEditorPage />} />
                    {/* Backward compat: old content-ops redirects to content */}
                    <Route path="/admin/content-ops" element={<Navigate to="/admin/content" replace />} />
                    <Route path="/admin/content-ops/editor/:id" element={<ContentEditorPage />} />
                    <Route path="/admin/video" element={<Navigate to="/admin/content?tab=video" replace />} />
                    <Route path="/admin/widgets" element={<WidgetsAdminPage />} />
                    <Route path="/admin/widget/new" element={<WidgetEditorPage />} />
                    <Route path="/admin/widget/edit/:id" element={<WidgetEditorPage />} />
                    <Route path="/2701" element={<TwoSevenZeroOnePage />} />
                    {/* Widget detail catch-all — must be last */}
                    <Route path="/:slug" element={<WidgetDetailPage />} />
                  </Routes>
                </AnimatePresence>
              </div>
            </main>
          </div>
        </Router>
      </AuthProvider>
    </UIProvider>
    </HelmetProvider>
  );
}

export default App;
